module.exports = __webpack_public_path__ + "img/parent-section.4e349813.jpg";